export const dateFormats = [
    "MM/dd/yyyy",
    "dd/MM/yyyy",
    "yyyy/MM/dd",
    "MM/dd/yy",
    "dd/MM/yy",
    "yy/MM/dd",
    /** dashes */
    "MM-dd-yyyy",
    "dd-MM-yyyy",
    "yyyy-MM-dd",
    "MM-dd-yy",
    "dd-MM-yy",
    "yy-MM-dd",
    /** dots */
    "MM.dd.yyyy",
    "dd.MM.yyyy",
    "yyyy.MM.dd",
    "MM.dd.yy",
    "dd.MM.yy",
    "yy.MM.dd"
];
export const defaultDateFormat = "MM/dd/yyyy";
